// source: pbtypes/gen/shape_map/polygon.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_eigen_lcm_Vector2d_pb = require('../../../pbtypes/gen/eigen_lcm/Vector2d_pb.js');
goog.object.extend(proto, pbtypes_gen_eigen_lcm_Vector2d_pb);
goog.exportSymbol('proto.shape_map.PolygonPb', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.shape_map.PolygonPb = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.shape_map.PolygonPb.repeatedFields_, null);
};
goog.inherits(proto.shape_map.PolygonPb, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.shape_map.PolygonPb.displayName = 'proto.shape_map.PolygonPb';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.shape_map.PolygonPb.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.shape_map.PolygonPb.prototype.toObject = function(opt_includeInstance) {
  return proto.shape_map.PolygonPb.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.shape_map.PolygonPb} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shape_map.PolygonPb.toObject = function(includeInstance, msg) {
  var f, obj = {
add: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
verticesList: jspb.Message.toObjectList(msg.getVerticesList(),
    pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb.toObject, includeInstance),
minHeight: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
maxHeight: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.shape_map.PolygonPb}
 */
proto.shape_map.PolygonPb.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.shape_map.PolygonPb;
  return proto.shape_map.PolygonPb.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.shape_map.PolygonPb} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.shape_map.PolygonPb}
 */
proto.shape_map.PolygonPb.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAdd(value);
      break;
    case 2:
      var value = new pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb;
      reader.readMessage(value,pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb.deserializeBinaryFromReader);
      msg.addVertices(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMinHeight(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMaxHeight(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.shape_map.PolygonPb.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.shape_map.PolygonPb.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.shape_map.PolygonPb} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.shape_map.PolygonPb.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAdd();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getVerticesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb.serializeBinaryToWriter
    );
  }
  f = message.getMinHeight();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getMaxHeight();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
};


/**
 * optional bool add = 1;
 * @return {boolean}
 */
proto.shape_map.PolygonPb.prototype.getAdd = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.shape_map.PolygonPb} returns this
 */
proto.shape_map.PolygonPb.prototype.setAdd = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * repeated eigen_lcm.Vector2dPb vertices = 2;
 * @return {!Array<!proto.eigen_lcm.Vector2dPb>}
 */
proto.shape_map.PolygonPb.prototype.getVerticesList = function() {
  return /** @type{!Array<!proto.eigen_lcm.Vector2dPb>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb, 2));
};


/**
 * @param {!Array<!proto.eigen_lcm.Vector2dPb>} value
 * @return {!proto.shape_map.PolygonPb} returns this
*/
proto.shape_map.PolygonPb.prototype.setVerticesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.eigen_lcm.Vector2dPb=} opt_value
 * @param {number=} opt_index
 * @return {!proto.eigen_lcm.Vector2dPb}
 */
proto.shape_map.PolygonPb.prototype.addVertices = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.eigen_lcm.Vector2dPb, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.shape_map.PolygonPb} returns this
 */
proto.shape_map.PolygonPb.prototype.clearVerticesList = function() {
  return this.setVerticesList([]);
};


/**
 * optional double min_height = 3;
 * @return {number}
 */
proto.shape_map.PolygonPb.prototype.getMinHeight = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.shape_map.PolygonPb} returns this
 */
proto.shape_map.PolygonPb.prototype.setMinHeight = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double max_height = 4;
 * @return {number}
 */
proto.shape_map.PolygonPb.prototype.getMaxHeight = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.shape_map.PolygonPb} returns this
 */
proto.shape_map.PolygonPb.prototype.setMaxHeight = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


goog.object.extend(exports, proto.shape_map);
